<template>
  <div class="history-item">
    <div v-if="item.type === 'route-details'">
      <router-link
        :to="{
                    name: 'routeinfo',
                    params: {
                        id: item.routeid,
                    },
                }"
      >
        <div>{{ item.routec }} {{ item.startc }} - {{ item.destinc }}</div>
      </router-link>
    </div>
    <div
      v-else-if="item.type === 'route-stop'"
      class="history-route-stop"
    >
      <FavouriteRoute
        :favourite-route="item"
      />
    </div>
  </div>
</template>

<script>
import FavouriteRoute from "../Favourite/FavouriteRoute";

export default {
  name: "HistoryItem",
  components: {FavouriteRoute},
  props: [
    'item',
  ],
  mounted() {
    console.log('item:', this.item);
  }
}
</script>

<style scoped>
.history-item {
  padding: 8px;
}

.history-route-stop {
  margin-left: -16px;
  margin-right: -16px;
}
</style>
